import { Injectable, signal, TemplateRef } from '@angular/core';

export interface ModalConfig {
  template: TemplateRef<any>;
  maxWidth?: string;
  onClose?: () => void;
}

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  isOpen = signal(false);
  modalTemplate = signal<TemplateRef<any> | null>(null);
  maxWidth = signal('800px');
  private onCloseCallback?: () => void;

  open(template: TemplateRef<any>, maxWidth: string = '800px', onClose?: () => void) {
    this.modalTemplate.set(template);
    this.maxWidth.set(maxWidth);
    this.onCloseCallback = onClose;
    this.isOpen.set(true);
    // Prevent body scroll
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.isOpen.set(false);
    this.modalTemplate.set(null);
    // Restore body scroll
    document.body.style.overflow = '';
    // Call onClose callback if provided
    if (this.onCloseCallback) {
      this.onCloseCallback();
      this.onCloseCallback = undefined;
    }
  }
}
